import { useEffect } from 'react';
import { MapViewport } from 'components/MapPage/MapViewport';
import { useUscgMapContext } from './CorporateViewTabs/LayersTab/UscgMapContext';
import { MapVisibleLayersPill } from './CorporateViewTabs/LayersTab/MapVisibleLayersPill';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

/** Viewports currently on screen. Exit hands the view back to one of these. */
const activeMapViewports = new Set<HTMLDivElement>();

export function UscgMapContainer() {
  const {
    mapView,
    mapViewElementRef,
    aiLayerPickMode,
    isMapVisible,
    startAiAreaDraw,
    cancelAiAreaDraw,
    aiAreaDrawActive,
    areaDrawControlsOnMap,
    symbolDrawingState,
  } = useUscgMapContext();
  const symbolDrawingActive = symbolDrawingState.geometryType != null;

  useEffect(() => {
    if (!mapView || !mapViewElementRef.current) return;

    const bench = document.getElementById('map-bench') as HTMLDivElement | null;
    const viewportContainer = mapViewElementRef.current;
    activeMapViewports.add(viewportContainer);
    mapView.container = viewportContainer;

    return () => {
      activeMapViewports.delete(viewportContainer);
      const sibling = [...activeMapViewports].find((node) => node.isConnected);
      const restoreTarget = sibling ?? bench;
      if (mapView && restoreTarget) {
        mapView.container = restoreTarget;
      }
    };
  }, [mapView, mapViewElementRef]);

  const showMapDrawButton =
    areaDrawControlsOnMap &&
    aiLayerPickMode &&
    isMapVisible &&
    !symbolDrawingActive;

  return (
    <div
      className="position-relative d-flex h-100 flex-grow-1"
      style={{ minHeight: 0 }}
      data-tour="aor-map-view"
    >
      <MapViewport mapViewElementRef={mapViewElementRef} isFullHeight />
      <div
        className="dark position-absolute"
        style={{ top: 12, left: 12, zIndex: 10 }}
      >
        <MapVisibleLayersPill />
      </div>
      {showMapDrawButton ? (
        <div
          className="position-absolute"
          style={{ top: 52, left: 12, zIndex: 10 }}
        >
          <StylishNewButton
            className="button--secondary"
            onClick={aiAreaDrawActive ? cancelAiAreaDraw : startAiAreaDraw}
            title={
              aiAreaDrawActive
                ? 'Cancel drawing'
                : 'Draw an area to scope AI to features inside it'
            }
          >
            {aiAreaDrawActive ? 'Cancel draw' : 'Draw area'}
          </StylishNewButton>
        </div>
      ) : null}
    </div>
  );
}
